import { useContext } from "react";
import { useParams } from "react-router-dom";
import { ContextOperation } from "../../../context/OperationContext";
import { ContextDamageForm } from "../DamageFormContext";
import DamageFormService from "./DamageFormService";

const useDamageFormActions = () => {
  const { tenant, setLoading} = useContext(ContextOperation);

  const { setGeneralInfo, setTask1, setTask2, setTask3 } = useContext(ContextDamageForm);

  const { id } = useParams();
  
  const getGeneralInfo = () => {
    if (!id) return;

    setLoading(true);
    DamageFormService.details.generalInfo.get.byId(id, tenant).then(
        (response) => {
            setGeneralInfo(response);
            setLoading(false);
        },
        (error) => {
            setLoading(false);
        }
    );
  }

  const getTask1 = () => {
    if (!id) return;
    
    setLoading(true);
    DamageFormService.details.task1.get.byId(id, tenant).then(
        (response) => {
            setTask1(response);
            setLoading(false);
        },
        (error) => {
            setLoading(false);
        }
    );
  }
  
  const getTask2 = () => {
    if (!id) return;

    setLoading(true);
    DamageFormService.details.task2.get.byId(id, tenant).then(
        (response) => {
            setTask2(response);
            setLoading(false);
        },
        (error) => {
            setLoading(false);
        }
    )
  }


  const getTask3 = () => {
    if (!id) return;

    setLoading(true);
    DamageFormService.details.task3.get.byId(id, tenant).then(
        (response) => {
            setTask3(response);
            setLoading(false);
        },
        () => {
            setLoading(false);
        }
    )
  }

  return {
    getGeneralInfo,
    getTask1,
    getTask2,
    getTask3,
  }

}

export default useDamageFormActions;